export default __webpack_public_path__ + "static/media/gbt.785714c4.jpg";